import { GetStaticProps } from 'next';
import { InfoCard } from '../../../components/glossary_v2/components/InfoCardDynamic';
import { KeywordGrid } from '../../../components/glossary_v2/components/KeywordGrid';
import { Search } from '../../../components/glossary_v2/components/Search';
import { Trending } from '../../../components/glossary_v2/components/Trending';

import {
  Breadcrumb,
  BREADCRUMB_TYPE,
} from '../../../components/Atoms/BreadCrumb';
import { ClearInNavbar } from '../../../components/Navbar/ClearNavbar';
import { banner_html_content } from '../../../components/banner_html/banner_html';
import { b2cData } from '../../../components/cms/layout/components/header';
import { ScrollTopButton } from '../../../components/glossary/components/ScrollTopButton';
import { GLOSSARY_SCHEMA } from '../../../components/glossary_v2/utils/contants';
import {
  ARTICLE_PAGE_SCHEMA,
  getBreadCrumbSchema,
} from '../../../constants/componentStaticData';
import { domainCode } from '../../../constants/staticPageConstants';
import { Meta } from '../../../layout/Meta';
import { returnNoProps } from '../../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../../utils/static-pages/utils';

const GlossaryPage = (): JSX.Element => {
  const BREADCRUMB: Array<BREADCRUMB_TYPE> = [
    { title: 'Home', link: '/glossary' },
  ];

  return (
    <div>
      <ClearInNavbar data={b2cData} />
      <div
        className="bannerFromHTML"
        dangerouslySetInnerHTML={{ __html: banner_html_content }}
      />
      <Meta
        title="FinTech Glossary - The Complete Financial Guide - ClearTax"
        description="FinTech Glossary is a complete financial guide to understanding the FinTech terms like taxation, personal finance, investments, trading, economy, and more."
        canonical="https://cleartax.in/glossary"
      />
      <div className="wg-container py-12 mx-auto sm:py-2">
        <Breadcrumb dataSet={BREADCRUMB} className="pt-6 sm:pt-3" />
        <h1 className="sm:text-s-32 text-s-56 mt-5 text-center font-bold">
          FinTech Glossary
        </h1>
        <ScrollTopButton />
        <Search domainVal={domainCode.cleartaxIn} />
        <Trending domainVal={domainCode.cleartaxIn} />
        <KeywordGrid />
        <InfoCard />
        <KeywordGrid />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              ARTICLE_PAGE_SCHEMA({
                title: GLOSSARY_SCHEMA.title,
                metaDesc: GLOSSARY_SCHEMA.metaDesc,
                url: GLOSSARY_SCHEMA.url,
                productType: GLOSSARY_SCHEMA.productType,
                datePublished: GLOSSARY_SCHEMA.datePublished,
                dateModified: GLOSSARY_SCHEMA.dateModified,
                logoUrl: GLOSSARY_SCHEMA.logoUrl,
              })
            ),
          }}
        ></script>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getBreadCrumbSchema(BREADCRUMB)),
          }}
        ></script>
      </div>
    </div>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  () => {
    return returnNoProps();
  }
);

export default GlossaryPage;
